// Halaman PUBLIK — dibuka pelanggan dari tautan WhatsApp, TANPA login.
// Sengaja TIDAK memakai instance axios `api` dari lib/api.js: interceptor
// permintaannya menempelkan Bearer token dari localStorage kalau ADA
// (mis. perangkat bersama yang sebelumnya dipakai login admin/kasir), dan
// interceptor responsnya bereaksi ke SETIAP 401 di aplikasi (hapus token +
// event logout). Endpoint publik ini tidak butuh auth sama sekali, jadi
// dipakai fetch polos supaya halaman ini benar-benar tidak bergantung sesi
// siapa pun yang kebetulan tersimpan di perangkat. Pola tampilan mengikuti
// CsatSurvey.jsx (acuan halaman publik lain di aplikasi ini).
// Nama toko di kop dibaca dari `branding` AuthContext (keputusan owner 24 Sep
// 2026, white-label): AuthProvider sudah membungkus rute ini dan memuatnya dari
// endpoint PUBLIK /config/branding — membaca nilainya tidak menambah panggilan
// ber-auth apa pun dari halaman ini.
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Frown, Clock } from "lucide-react";
import { API } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import InvoicePreview from "../components/faktur/InvoicePreview";
import LoadingState from "@/components/ui/loading-state";

export default function FakturPublik() {
  const { token } = useParams();
  const { branding } = useAuth();
  const namaToko = branding?.nama_toko_sendiri || "EppleHub";
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [status, setStatus] = useState(0);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError("");
    fetch(`${API}/faktur/publik/${token}`)
      .then(async (res) => {
        const body = await res.json().catch(() => ({}));
        if (!res.ok) {
          const err = new Error(body?.detail || "");
          err.status = res.status;
          throw err;
        }
        return body;
      })
      .then((body) => { if (alive) setData(body); })
      .catch((err) => {
        if (!alive) return;
        setStatus(err.status || 0);
        setError(
          err.status
            ? (err.message || "Tautan faktur tidak dapat dibuka. Coba lagi beberapa saat.")
            : "Gagal memuat faktur. Periksa koneksi internet Anda lalu coba lagi."
        );
      })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [token, retry]);

  return (
    <main className="invoice-public">
      {loading && <div className="invoice-public-state no-print" data-testid="faktur-publik-loading">
        <LoadingState loading jumlahKartu={1} />
      </div>}
      {!loading && error && <div className="invoice-public-state no-print" data-testid="faktur-publik-error" role="alert">
        {status === 410 ? <Clock className="w-10 h-10 mx-auto mb-4" /> : <Frown className="w-10 h-10 mx-auto mb-4" />}
        <h1 className="font-semibold text-lg">{status === 410 ? "Tautan sudah kedaluwarsa" : "Faktur belum dapat dibuka"}</h1>
        <p className="mt-3 text-sm">{error}</p>
        <button type="button" onClick={() => setRetry(v => v + 1)}>Coba lagi</button>
        <p className="mt-5 text-xs">{namaToko}</p>
      </div>}
      {!loading && !error && data && <InvoicePreview data={data} publik />}
    </main>
  );
}
